import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { tap, catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Injectable({
	providedIn: 'root'
})
export class BoardsService {
	deleteFailed = 'data delete failed' ; deleteSuccess = 'data delete success' ; insertFailed = 'data insert failed' ; dataFails = 'data fails' ; dataSuccess = 'data success'
	contentType = 'application/json, application/x-www-form-urlencoded;charset=ISO-8859-15'; datainsertedSuccess = 'data inserted success'
	hedr = new HttpHeaders().set('Content-Type', 'application/json');
	constructor(private readonly http : HttpClient) { }

	getBoardList(): Observable<any> {
		const httpCustomOptions = {
			headers: new HttpHeaders({
				'Content-Type': this.contentType,
				'Accept': 'application/json',
			})
		};
		return this.http
			.get(`${environment.baseAPIURL}/api/v1/getboard`, httpCustomOptions)
			.pipe(
				tap(_ => this.log(this.dataSuccess)),
				catchError(this.handleError<any>(this.dataFails))
			);
	}

	addoneTimeTask(arrData: any): Observable<any> {
		const headers = this.hedr
		return this.http
			.post(`${environment.baseAPIURL}/api/v1/board/addOneTimeTask`, arrData, { headers, responseType: 'text' })
			.pipe(
				tap(_ => this.log(this.datainsertedSuccess)),
				catchError(this.handleError<any>(this.insertFailed))
			);
	}

	addperiodTask(arrData: any): Observable<any> {
		const headers = this.hedr
		return this.http
			.post(`${environment.baseAPIURL}/api/v1/board/addPeriodTask`, arrData, { headers, responseType: 'text' })
			.pipe(
				tap(_ => this.log(this.datainsertedSuccess)),
				catchError(this.handleError<any>(this.insertFailed))
			);
	}

	addnewcontingencyTask(arrData: any): Observable<any> {
		const headers = this.hedr
		return this.http
			.post(`${environment.baseAPIURL}/api/v1/board/addContingencyTask`, arrData, { headers, responseType: 'text' })
			.pipe(
				tap(_ => this.log(this.datainsertedSuccess)),
				catchError(this.handleError<any>(this.insertFailed))
			);
	}

	savenewcontingencyTask(arrData: any): Observable<any> {
		return this.http
			.put(`${environment.baseAPIURL}/api/v1/board/updateContingencyTask`, arrData)
			.pipe(
				tap(_ => this.log(this.datainsertedSuccess)),
				catchError(this.handleError<any>(this.insertFailed))
			);
	}

	addWeeklyTask(arrData: any): Observable<any> {
		const headers = this.hedr
		return this.http
			.post(`${environment.baseAPIURL}/api/v1/board/addWeeklyTask`, arrData, { headers, responseType: 'text' })
			.pipe(
				tap(_ => this.log(this.datainsertedSuccess)),
				catchError(this.handleError<any>(this.insertFailed))
			);
	}

	addMonthlyTask(arrData: any): Observable<any> {
		const headers = this.hedr
		return this.http
			.post(`${environment.baseAPIURL}/api/v1/board/addMonthlyTask`, arrData, { headers, responseType: 'text' })
			.pipe(
				tap(_ => this.log(this.datainsertedSuccess)),
				catchError(this.handleError<any>(this.insertFailed))
			);
	}

	addFromTemplateTask(arrData: any): Observable<any> {
		const headers = this.hedr
		return this.http
			.post(`${environment.baseAPIURL}/api/v1/board/addFromTemplate`, arrData, { headers, responseType: 'text' })
			.pipe(
				tap(_ => this.log(this.datainsertedSuccess)),
				catchError(this.handleError<any>(this.insertFailed))
			);
	}

	createContingencyTask(arrData: any): Observable<any> {
		const headers = this.hedr
		return this.http
			.post(`${environment.baseAPIURL}/api/v1/board/addContingency`, arrData, { headers, responseType: 'text' })
			.pipe(
				tap(_ => this.log(this.datainsertedSuccess)),
				catchError(this.handleError<any>(this.insertFailed))
			);
	}

	addContingencyTask(arrData: any): Observable<any> {
		const headers = this.hedr
		return this.http
			.post(`${environment.baseAPIURL}/api/v1/board/addContingencylist`, arrData, { headers, responseType: 'text' })
			.pipe(
				tap(_ => this.log(this.datainsertedSuccess)),
				catchError(this.handleError<any>(this.insertFailed))
			);
	}


	getDetails(intuserid, boardID, teamID, completed): Observable<any> {
		const userData = sessionStorage?.getItem('FGA');
		let roles:any
		let isAdmin = false
		if (userData) {
			roles = JSON.parse(userData)?.roles
			const role = roles?.filter(r => r.displayName == 'Task Manager Admin') // NOSONAR
			isAdmin = role && role.length > 0 ? true : false;
		}
		const httpCustomOptions = {
			headers: new HttpHeaders({
				'Content-Type': this.contentType,
				'Accept': 'application/json',
			})
		};
		return this.http
			.get(`${environment.baseAPIURL}/api/v1/board/getAllTasks?P_BoardID=${boardID}&P_Admin=${isAdmin}&P_TeamID=${teamID}&P_ShowCompleted=${completed}&P_AuthenticatedUser=${intuserid}`, httpCustomOptions)
			.pipe(
				tap(_ => this.log(this.dataSuccess)),
				catchError(this.handleError<any>(this.dataFails))
			);
	}

	getboardtaskslist(): Observable<any> {
		const httpCustomOptions = {
			headers: new HttpHeaders({
				'Content-Type': this.contentType,
				'Accept': 'application/json',
			})
		};
		return this.http
			.get(`${environment.baseAPIURL}/api/v1/getboardtaskslist`, httpCustomOptions)
			.pipe(
				tap(_ => this.log(this.dataSuccess)),
				catchError(this.handleError<any>(this.dataFails))
			);
	}





	getTeamsList(): Observable<any> {
		const httpCustomOptions = {
			headers: new HttpHeaders({
				'Content-Type': this.contentType,
				'Accept': 'application/json',
			})
		};
		return this.http
			.get(`${environment.baseAPIURL}/api/v1/teams/getTeamsList`, httpCustomOptions)
			.pipe(
				tap(_ => this.log(this.dataSuccess)),
				catchError(this.handleError<any>(this.dataFails))
			);
	}

	markAsIncomplete(arrData: any): Observable<any> {
		return this.http
			.put(`${environment.baseAPIURL}/api/v1/board/updateUnComplete`, arrData)
			.pipe(
				tap(_ => this.log(this.datainsertedSuccess)),
				catchError(this.handleError<any>(this.insertFailed))
			);
	}

	markAsComplete(arrData: any): Observable<any> {
		return this.http
			.put(`${environment.baseAPIURL}/api/v1/board/updateComplete`, arrData)
			.pipe(
				tap(_ => this.log(this.datainsertedSuccess)),
				catchError(this.handleError<any>(this.insertFailed))
			);
	}

	lateconfStatus(): Observable<any> {
		const httpCustomOptions = {
			headers: new HttpHeaders({
				'Content-Type': this.contentType,
				'Accept': 'application/json',
			})
		};
		return this.http
			.get(`${environment.baseAPIURL}/api/v1/board/changelateConfStatus/status?status=late`, httpCustomOptions)
			.pipe(
				tap(_ => this.log(this.dataSuccess)),
				catchError(this.handleError<any>(this.dataFails))
			);
	}

	changelateconfStatus(reasonNumber): Observable<any> {
		const httpCustomOptions = {
			headers: new HttpHeaders({
				'Content-Type': this.contentType,
				'Accept': 'application/json',
			})
		};
		return this.http
			.get(`${environment.baseAPIURL}/api/v1/board/changelateConfStatus/reason${reasonNumber}`, httpCustomOptions)
			.pipe(
				tap(_ => this.log(this.dataSuccess)),
				catchError(this.handleError<any>(this.dataFails))
			);
	}

	savelateconfStatus(arrData: any): Observable<any> {
		return this.http
			.put(`${environment.baseAPIURL}/api/v1/board/changelateConfStatus`, arrData)
			.pipe(
				tap(_ => this.log(this.datainsertedSuccess)),
				catchError(this.handleError<any>(this.insertFailed))
			);
	}

	saveperiodTask(arrData: any): Observable<any> {
		return this.http
			.put(`${environment.baseAPIURL}/api/v1/board/updatePeriodTask`, arrData)
			.pipe(
				tap(_ => this.log(this.datainsertedSuccess)),
				catchError(this.handleError<any>(this.insertFailed))
			);
	}

	saveoneTimeTask(arrData: any): Observable<any> {
		return this.http
			.put(`${environment.baseAPIURL}/api/v1/board/updateOneTimeTask`, arrData)
			.pipe(
				tap(_ => this.log(this.datainsertedSuccess)),
				catchError(this.handleError<any>(this.insertFailed))
			);
	}




	getMyTasksDetails(coveredtasks, intuserid,): Observable<any> {
		const userData = sessionStorage?.getItem('FGA');
		let roles:any
		let isAdmin = false
		if (userData) {
			roles = JSON.parse(userData)?.roles
			const role = roles?.filter(r => r.displayName == 'Task Manager Admin') // NOSONAR
			isAdmin = role && role.length > 0 ? true : false;
		}
		const httpCustomOptions = {
			headers: new HttpHeaders({
				'Content-Type': this.contentType,
				'Accept': 'application/json',
			})
		};
		return this.http
			.get(`${environment.baseAPIURL}/api/v1/board/getMyTasks?ShowCoveredTasks=${coveredtasks}&P_Admin=${isAdmin}&AuthenticatedUser=${intuserid}`, httpCustomOptions)
			.pipe(
				tap(_ => this.log(this.dataSuccess)),
				catchError(this.handleError<any>(this.dataFails))
			);
	}


	deleteBoardTask(boardTaskID) {
		return this.http
			.delete(`${environment.baseAPIURL}/api/v1/board/deleteBoardTask?p_boardTaskID=${boardTaskID}`)
			.pipe(
				tap(_ => this.log(this.deleteSuccess)),
				catchError(this.handleError<any>(this.deleteFailed))
			);
	}

	deleteContingenyList() {
		return this.http
			.delete(`${environment.baseAPIURL}/api/v1/board/deleteAllContingencylist`)
			.pipe(
				tap(_ => this.log(this.deleteSuccess)),
				catchError(this.handleError<any>(this.deleteFailed))
			);
	}

	deleteContingenyRow(arrData) {
		return this.http
			.delete(`${environment.baseAPIURL}/api/v1/board/deleteContingencylist`, arrData)
			.pipe(
				tap(_ => this.log(this.deleteSuccess)),
				catchError(this.handleError<any>(this.deleteFailed))
			);
	}

	updateCal(): Observable<any> {

		const requestOptions: Object = {
			responseType: 'text'
		}

		return this.http
			.get(`${environment.baseAPIURL}/api/v1/updateCalendar`, requestOptions)
			.pipe(
				tap(_ => this.log(this.dataSuccess)),
				catchError(this.handleError<any>(this.dataFails))
			);

	}



	private handleError<T>(_operation, result?: T) {
		return (error: any): Observable<T> => {
			console.info(error); // log to console instead
			return of(result as T);
		};
	}

	/** Log a message */
	private log(message: string) {
		console.info('Message: ' + message);
	}

}
